module.exports = __webpack_public_path__ + "static/media/kost.48b750a2.png";